import { HIDE_CHAT_PANEL, CLOSE_CHAT, SHOW_CHAT_PANEL, RECEIVE_EVENT, INIT_EXTERNAL_LISTENER, RECEIVE_MYDPD_CHAT_DETAILS, REQUEST_CHAT_DETAILS, GET_CHAT_CONFIG, SHOW_CHAT_PROMPT } from "./Constants.js";
import { receiveQueueMessages, receiveQueuePositionMessages } from "./ChatActions.js";
import { initiateChat } from "./LiveActions.js";
function initExternalListener() {
  return async (dispatch, getState) => {
    const obj = document.getElementById("chat-view-wrapper");
    const chatState = getState().chat;
    obj.addEventListener("dpd/cbot/fmp-submit", function(e) {
      if (!chatState.chatBot.actionPending) {
        return false;
      }
      dispatch({
        type: RECEIVE_EVENT,
        action: "success"
      });
      dispatch(showChatPanel("inflight-success"));
    });
    obj.addEventListener("dpd/cbot/fmp-cancel", function(e) {
      if (!chatState.chatBot.actionPending) {
        return false;
      }
      dispatch({
        type: RECEIVE_EVENT,
        action: "cancel"
      });
      dispatch(showChatPanel());
    });
    return {
      type: INIT_EXTERNAL_LISTENER
    };
  };
}
function requestChatDetails(parcelNumber, parcelCode, orderId, postCode) {
  return {
    type: REQUEST_CHAT_DETAILS,
    parcelCode,
    parcelNumber,
    orderId,
    postCode
  };
}
const initializeChat = (config, apiClient, parcelCode, parcelNumber, postCode, orderId, caseId, collectionReference, collectionPostcode) => (dispatch, getState) => {
  var _a;
  const { botAvailable } = config;
  const state = getState();
  const collectionPostcodeFromState = (_a = state.chat.config) == null ? void 0 : _a.collectionPostcode;
  const enhancedConfig = {
    ...apiClient.chatConfig,
    // Preserve original config including liveagent
    ...config,
    // Override with API response
    parcelCode,
    parcelNumber,
    postCode,
    orderId,
    caseId,
    collectionReference,
    collectionPostcode: collectionPostcode || collectionPostcodeFromState,
    botAvailable
  };
  dispatch({
    type: RECEIVE_MYDPD_CHAT_DETAILS,
    details: enhancedConfig
  });
  dispatch(receiveQueueMessages(config.educationalMessages));
  dispatch(receiveQueuePositionMessages(config.queueMessages));
  dispatch(initiateChat(apiClient));
  return enhancedConfig;
};
function fetchChatDetails(apiClient, parcelCode, parcelNumber, orderId, postCode, collectionReference, collectionPostcode) {
  return async (dispatch) => {
    dispatch(requestChatDetails(parcelNumber, parcelCode, orderId, postCode));
    const { isSalesforceCaseRequired } = apiClient.chatConfig;
    if (parcelNumber || parcelCode || !isSalesforceCaseRequired) {
      const queryParams = {};
      if (parcelCode) queryParams.parcelCode = parcelCode;
      if (parcelNumber) queryParams.parcelNumber = parcelNumber;
      if (orderId) queryParams.orderId = orderId;
      if (postCode) queryParams.postCode = postCode;
      const configData = await apiClient.get(GET_CHAT_CONFIG, {}, queryParams);
      const config = dispatch(
        initializeChat(
          configData,
          apiClient,
          parcelCode,
          parcelNumber,
          postCode,
          orderId,
          null,
          // caseId
          collectionReference,
          collectionPostcode
        )
      );
      return config;
    }
  };
}
function fetchInitialConfig(apiClient, parcelCode, parcelNumber, orderId, postCode, collectionReference, collectionPostcode) {
  return async (dispatch) => {
    dispatch(requestChatDetails(parcelCode, parcelNumber, orderId, postCode));
    try {
      const config = await dispatch(
        fetchChatDetails(
          apiClient,
          parcelCode,
          parcelNumber,
          orderId,
          postCode,
          collectionReference,
          collectionPostcode
        )
      );
      const isAvailable = config.botAvailable === true || config.advisorAvailable === true;
      if (!isAvailable) {
        return;
      }
      if (config.showDirectly) {
        dispatch(showChatPrompt());
      } else {
        setTimeout(() => {
          dispatch(showChatPrompt());
        }, config.loadTime * 1e3);
      }
    } catch (e) {
    }
  };
}
function showChatPrompt() {
  return {
    type: SHOW_CHAT_PROMPT
  };
}
function showChatPanel(flag) {
  return {
    type: SHOW_CHAT_PANEL,
    flag
  };
}
function hideChatPanel() {
  return {
    type: HIDE_CHAT_PANEL
  };
}
function closeChat() {
  return {
    type: CLOSE_CHAT
  };
}
export {
  closeChat,
  fetchInitialConfig,
  hideChatPanel,
  initExternalListener,
  initializeChat,
  showChatPanel,
  showChatPrompt
};
//# sourceMappingURL=ChatBarActions.js.map
